var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "sendCode"
    }
  }, [_c('button', {
    staticClass: "sendCodeBtn myBtn",
    class: {
      inactive: _vm.isSending
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isSending
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t(_vm.codeBtnTxt)) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }